import Api from '@/api/api.js'
import configApi from '@/api/config/_api_config'

export default {
    async lireConsommablesSoin(protocoleId) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const token = access && access.data && access.data.access_token
        if (!token) throw new Error('Accès aux soins indisponible.')
        const response = await Api().get('/v1/care-consumables/catalog', {
            params: { protocole_id: protocoleId },
            med_access_scoped: true, timeout: 20000, headers: { 'X-Soins-Access': token }
        })
        return response.data
    },
    async lireFacturationConsommablesSoin(item) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const response = await Api().get(`/v1/care-items/${item.care_item_id}/consumables-billing`, {
            params: { type: item.type }, med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async confirmerFacturationConsommable(id) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const response = await Api().post(`/v1/care-consumables/${id}/confirm-billing`, {}, {
            med_access_scoped: true, timeout: 20000, headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async rapprocherStockConsommables() {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const response = await Api().post('/v1/care-consumables/reconcile-stock', {}, {
            med_access_scoped: true, timeout: 35000, headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async lirePlanAdministrationPatient(patient_id, consultation_id) {
        const access = (await configApi().post('/infirmier/tableau-access', {}, { timeout: 20000 })).data
        const token = access && access.data && access.data.access_token
        if (!token) throw new Error('Accès infirmier indisponible.')
        const response = await Api().get(`/v1/patients/${patient_id}/care-timeline`, {
            params: consultation_id ? { consultation_id } : {},
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Infirmier-Access': token }
        })
        return response.data
    },
    // Même plan, en lecture, pour le médecin (dossier › Soins à faire) ; repli sur l'accès infirmier si le compte n'a pas le rôle médecin.
    async lirePlanAdministrationPatientMedecin(patient_id, consultation_id) {
        let token = null
        try {
            const access = (await configApi().post('/medecin/tableau-access', {}, { timeout: 20000 })).data
            token = access && access.data && access.data.access_token
        } catch (error) { token = null }
        if (!token) return this.lirePlanAdministrationPatient(patient_id, consultation_id)
        const response = await Api().get(`/v1/patients/${patient_id}/care-timeline/medecin`, {
            params: consultation_id ? { consultation_id } : {},
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Med-Access': token }
        })
        return response.data
    },
    async agirSurSoinPatient(item, action, extra = {}) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const token = access && access.data && access.data.access_token
        if (!token) throw new Error('Accès aux soins indisponible.')
        const payload = {
            patient_id: item.patient_id,
            consultation_id: item.consultation_id,
            protocole_id: item.protocole_id,
            type: item.type,
            suivi_acte_id: item.suivi_acte_id || undefined,
            ...extra
        }
        let body = payload
        if (extra.document) {
            body = new FormData()
            Object.keys(payload).forEach(key => {
                if (payload[key] !== undefined && payload[key] !== null) body.append(key, payload[key])
            })
        }
        const response = await Api().post(`/v1/care-items/${item.care_item_id}/${action}`, body, {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': token, 'Content-Type': extra.document ? undefined : 'application/json' }
        })
        return response.data
    },
    async lireDocumentInterruption(id) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const token = access && access.data && access.data.access_token
        if (!token) throw new Error('Accès aux soins indisponible.')
        const response = await Api().get(`/v1/care-interruption-documents/${id}`, {
            med_access_scoped: true, timeout: 20000, responseType: 'blob',
            headers: { 'X-Soins-Access': token }
        })
        return response.data
    },
    async lireSoinsRealises(consultation_id, patient_id) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const response = await Api().get('/consultations/soins-realises', {
            params: { consultation_id, patient_id }, med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async documenterSoinRealise(data) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const response = await Api().post('/consultations/soins-realises', data, {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async contresignerSoinRealise(id, consultation_id, patient_id) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        const response = await Api().post(`/consultations/soins-realises/${id}/contresigner`, { consultation_id, patient_id }, {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async lireBrouillonPlanSoins(consultation_id, evolution_id) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        if (!access || !access.data || !access.data.access_token) throw new Error('Accès au brouillon indisponible.')
        const response = await Api().get('/protocoles/soins/brouillon', {
            params: { consultation_id, evolution_id }, med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data.data
    },
    async sauverBrouillonPlanSoins(consultation_id, evolution_id, brouillon) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        if (!access || !access.data || !access.data.access_token) throw new Error('Accès au brouillon indisponible.')
        const response = await Api().put('/protocoles/soins/brouillon', { consultation_id, evolution_id, brouillon }, {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async supprimerBrouillonPlanSoins(consultation_id, evolution_id) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        if (!access || !access.data || !access.data.access_token) throw new Error('Accès au brouillon indisponible.')
        const response = await Api().delete('/protocoles/soins/brouillon', {
            params: { consultation_id, evolution_id }, med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async enregistrerPlanSoinsExpress(data) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        if (!access || !access.success || !access.data || !access.data.access_token) {
            throw new Error('Accès au plan de soins indisponible.')
        }
        const response = await Api().post('/protocoles/plan-soins-express', data, {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    // Recette du 03/10 : état (et contenu) d'un plan à modifier tant que la caisse ne l'a pas réglé.
    async etatModificationPlanSoins(protocole_id) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        if (!access || !access.success || !access.data || !access.data.access_token) {
            throw new Error('Accès au plan de soins indisponible.')
        }
        const response = await Api().get('/protocoles/plan-soins-express/' + Number(protocole_id) + '/modification', {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async supprimerPlanSoins(protocole_id) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        if (!access || !access.success || !access.data || !access.data.access_token) {
            throw new Error('Accès au plan de soins indisponible.')
        }
        const response = await Api().delete('/protocoles/plan-soins-express/' + Number(protocole_id), {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async marquerSoinFait(data) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        if (!access || !access.success || !access.data || !access.data.access_token) {
            throw new Error('Accès aux soins indisponible.')
        }
        const response = await Api().post('/protocoles/soins/faire', data, {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    async agirSurActe(data) {
        const access = (await configApi().post('/soins/access', {}, { soins_access_scoped: true, timeout: 20000 })).data
        if (!access || !access.success || !access.data || !access.data.access_token) {
            throw new Error('Accès aux actes indisponible.')
        }
        const response = await Api().post('/protocoles/soins/actes/executer', data, {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Soins-Access': access.data.access_token }
        })
        return response.data
    },
    saveConsultationProtocoleSoins(data) {
        const promise = Api().post('/protocoles/store', data)
        return promise.then(response => response.data)
    },

    getConsultationProtocoleSoins(data) {
        const promise = Api().post('/protocoles/show', data)
        return promise.then(response => response.data)
    },

    saveConsultationCatConsigne(data) {
        const promise = Api().post('/protocoles/save/cat-consigne', data)
        return promise.then(response => response.data)
    },

    deleteConsultationCatConsigne(data) {
        const promise = Api().post('/protocoles/delete/cat-consigne', data)
        return promise.then(response => response.data)
    },

    deleteProtocoleSoins(data) {
        const promise = Api().post('/protocoles/delete', data)
        return promise.then(response => response.data)
    },

    getTraitementEnCours(data) {
        const promise = Api().post('/protocoles/show/traitement-en-cours', data)
        return promise.then(response => response.data)
    },

    saveProcessStatus(data) {
        const promise = Api().post('/protocoles/set-process/traitement-en-cours', data)
        return promise.then(response => response.data)
    },

    getProtocoleData(data) {
        const promise = Api().post('/protocoles/show/protocole-data', data)
        return promise.then(response => response.data)
    },

    saveProtocoleData(data) {
        const promise = Api().post('/protocoles/store/protocole-data', data)
        return promise.then(response => response.data)
    },

    deleteProtocoleData(data) {
        const promise = Api().post('/protocoles/delete/protocole-data', data)
        return promise.then(response => response.data)
    },

    getPatientsAdmissionEnCours(data) {
        const promise = Api().post('/protocole-soins/patients/admission-encours', data)
        return promise.then(response => response.data)
    },

    editProtocoleData(data) {
        const promise = Api().post('/protocoles/edit/protocole-data', data)
        return promise.then(response => response.data)
    },

    editProtocoleAdmissionItem(data) {
        const promise = Api().post('/protocoles/edit/admission-data', data)
        return promise.then(response => response.data)
    },

    deleteProtocoleItem(data) {
        const promise = Api().post('/protocoles/delete/protocole-item', data)
        return promise.then(response => response.data)
    },
}
